import "./styles.css";
import { renderDataPage } from "./pages/data";
import { renderDiagnosisPage } from "./pages/diagnosis";
import { renderLibraryPage } from "./pages/library";
import { renderReadPage } from "./pages/read";
import { renderSettingsPage } from "./pages/settings";
import { renderStatisticsPage } from "./pages/statistics";
import { startRouter } from "./router";
import { renderShell } from "./ui/layout";
import { mountToast } from "./ui/toast";
import type { Route } from "./types";

async function renderRoute(route: Route): Promise<void> {
  renderShell(route, `<p class="muted">加载中…</p>`);

  switch (route.name) {
    case "read":
      await renderReadPage(route);
      break;
    case "library":
      await renderLibraryPage(route);
      break;
    case "statistics":
      await renderStatisticsPage(route);
      break;
    case "diagnosis":
      await renderDiagnosisPage(route);
      break;
    case "data":
      await renderDataPage(route);
      break;
    case "settings":
      await renderSettingsPage(route);
      break;
    default:
      await renderReadPage(route);
  }
}

mountToast();
startRouter((route) => {
  void renderRoute(route);
});
